import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import {
    Box,
    Text,
    Skeleton
} from '@salesforce/retail-react-app/app/components/shared/ui'

/* Hooks */
import { useOptimizely } from '../../../contexts/optimizely-context'

/* Utils */
import { renderComponentsSwitch } from '../../../components/optimizely/utils/contentRenderer'

const ExclusiveRewardsBlockCMS = React.forwardRef(({ loyaltyData, isLoyaltyDataLoading }, ref) => {
    const { rewardPageBlock, isOptimizelyLoading } = useOptimizely()
    const [cmsAndLoyaltyDataLoaded, setCmsAndLoyaltyDataLoaded] = useState(false)

    // This will fallback CMS
    const hardCodedData = {
        title: 'Enjoy Your Exclusive Rewards',
        subTitle: "And just like that... thanks to your points and your tier status, you're already earning rewards. Don't miss out!"
    }

    const rewards = loyaltyData?.rewards

    useEffect(() => {
        if (!isOptimizelyLoading && !isLoyaltyDataLoading) {
            setCmsAndLoyaltyDataLoaded(true)
        }
    }, [!isOptimizelyLoading, !isLoyaltyDataLoading])

    return (
        <Box ref={ref}>
            <Box>
                {rewardPageBlock && rewardPageBlock?.RewardTitleResponsiveText ? (
                    renderComponentsSwitch(rewardPageBlock?.RewardTitleResponsiveText?.Expanded)
                ) : (
                    <Box dangerouslySetInnerHTML={{ __html: hardCodedData.title }} />
                )}

                {rewardPageBlock && rewardPageBlock?.RewardSubtitleResponsiveText &&
                    renderComponentsSwitch(rewardPageBlock?.RewardSubtitleResponsiveText?.Expanded)
                }

                {rewardPageBlock && rewardPageBlock?.RewardDescriptionResponsiveText ? (
                    renderComponentsSwitch(rewardPageBlock?.RewardDescriptionResponsiveText?.Expanded)
                ) : (
                    <Text>
                        {hardCodedData.subTitle}
                    </Text>
                )}

                <Skeleton isLoaded={cmsAndLoyaltyDataLoaded}>
                    {rewards?.map((reward, index) => {
                        const availableCustomerRewardId = reward['tile-content-id']
                        const availableCustomerReward = rewardPageBlock?.RewardTileList?.filter((item) => item?.ContentLink?.Expanded?.RewardTileSFID === availableCustomerRewardId)
                        if (availableCustomerReward?.length > 0) {
                            return renderComponentsSwitch(availableCustomerReward[0]?.ContentLink?.Expanded)
                        }
                    })}
                </Skeleton>
            </Box>
        </Box>
    )
})

ExclusiveRewardsBlockCMS.propTypes = {
    loyaltyData: PropTypes.object,
    isLoyaltyDataLoading: PropTypes.bool
}

export default ExclusiveRewardsBlockCMS
